<template>
   <div>
      <atom-title
         title="Register"
         :color="formSubmitted ? 'success' : 'secondary'"
      />
      <error-list :errors="errors.non_field"/>
      <form v-if="!formSubmitted" @submit.prevent="handleSubmit">
         <input-field
            label="First name"
            placeholder="Enter first name"
            v-model="fields.first_name"
            :errors="errors.first_name"
            required
         />
         <input-field
            label="Last name"
            placeholder="Enter last name"
            v-model="fields.last_name"
            :errors="errors.last_name"
            required
         />
         <input-field
            label="Phone No"
            placeholder="Enter phone number"
            v-model="fields.phone_no"
            :errors="errors.phone_no"
            required
         />
         <input-field
            label="Email"
            placeholder="Enter email address"
            type="email"
            v-model="fields.email"
            :errors="errors.email"
            required
         />
         <input-field
            label="Password"
            placeholder="Enter password"
            type="password"
            v-model="fields.password"
            :errors="errors.password"
            required
         />
         <input-field
            label="Confirm password"
            placeholder="Re-enter password"
            type="password"
            v-model="fields.confirm_password"
            :errors="errors.confirm_password"
            required
         />
         <submit-btn
            label="Register"
            :isLoading="isSubmittingForm"
         />
      </form>
      <success-msg
         :isSuccess="formSubmitted"
         text="You have been successfully registered to MEP. But
         before you log in, please activate your account using
         the link in the mail we've just sent you. Thank you!"
      />
   </div>
</template>

<script>
import AtomTitle from '../../../atoms/Login/Title';
import ErrorList from '../../../molecules/Login/Errors';
import InputField from '../../../molecules/Login/InputField';
import SuccessMsg from '../../../molecules/Register/SuccessMsg';
import SubmitBtn from '../../../molecules/Login/SubmitBtn';
import { mapActions } from 'vuex';

export default {
   name: 'register-form',
   components: {
      ErrorList,
      InputField,
      SubmitBtn,
      AtomTitle,
      SuccessMsg,
   },
   data()
   {
      const fieldNames = ["first_name", "last_name", "email", "phone_no", "password", "confirm_password", 'non_field'];
      const fields = {};
      const errors = {};
      
      fieldNames.forEach(name =>
      {
         fields[name] = "";
         errors[name] = [];
      });
      return {
         fields,
         errors,
         formSubmitted: false,
         isSubmittingForm: false,
      }
   },
   created()
   {
      
   },
   methods: {
      ...mapActions('users', ['registerUser']),
      setErrors(errors)
      {
         const fieldNames = ["first_name", "last_name", "email", "phone_no", "password", "confirm_password", "non_field"];
         fieldNames.forEach( field =>
         {
            this.errors[field] = errors[field] ? errors[field] : [];
         });
      },
      async handleSubmit()
      {
         if (this.isSubmittingForm) return;
         try
         {
            this.isSubmittingForm = true;
            this.setErrors({}); // reset the errors
            const response = await this.registerUser(this.fields);
            const result = response.data;
            (result.success) ?
               (this.formSubmitted = true)
               :
               this.setErrors(result.errors);

         }
         catch (error)
         {
            this.errors.non_field = [error.message];
            if (!error.response)
            {
               this.errors.non_field = ["Couldn't connect to server. (Please check internet connection)"];
            }
         }
         this.isSubmittingForm = false;
      }
   }
}
</script>
